module.exports = __webpack_public_path__ + "img/10.ef3c2d4f.png";